import {
  Breadcrumb,
  ChatBubbleLeftRightIcon,
  DownloadExcel,
  ErrorAlert,
  LinkBtn,
  PageHero,
  SearchToggle,
  SmsBalanceAlert,
  Table,
  TableRowsPerPage,
  useDelete,
  useFetchData,
  useSearch,
  useTableColumns,
} from "@";
import { getMessages } from "./utils/api";
import MultiSearch from "./components/MultiSearch";
import { excelHeaderCellsName, searchValues } from "./utils/options";
import { TableActions, tableColumns } from "./components/TableOptions";

const Index = () => {
  const links = [{ name: "الرسائل المؤتمتة", link: "" }];

  // Initialize search state
  const { search, updateSearch } = useSearch(searchValues);

  // Fetch data with search parameters
  const { data, setData, isLoading, error, pg, fetchData, updatePg } =
    useFetchData({
      fun: getMessages,
      params: [search.values],
    });

  // Handle delete action
  const { deleteHandler } = useDelete(data, setData, "automatedMessages");

  // Define table columns with actions
  const columns = useTableColumns(
    tableColumns,
    (row) => <TableActions row={row} deleteHandler={deleteHandler} />,
    1,
  );

  return (
    <>
      {/* error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />
      <SmsBalanceAlert />

      <main className="table-card relative">
        <PageHero
          eyebrow="الرسائل / التلقائية"
          title="الرسائل المؤتمتة"
          count={pg.rows}
          icon={ChatBubbleLeftRightIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size: size })}
          />

          <DownloadExcel
            fetch={getMessages}
            length={data?.length}
            search={search.values}
            headerCellsName={excelHeaderCellsName}
          />

          <LinkBtn to="/automated/create" create />

          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        {/* Multi Search inputs */}
        <MultiSearch
          search={search}
          onSubmit={fetchData}
          dataLength={data?.length}
          updateSearch={updateSearch}
        />

        {/* table */}
        <Table
          data={data}
          pagination={pg}
          columns={columns}
          isLoading={isLoading}
          pageChange={(page) => updatePg({ page: page })}
          perRowsChange={(size) => updatePg({ size: size })}
        />
      </main>
    </>
  );
};

export default Index;
